import { resolveTenantAppCode } from 'app/shared/api/tenant-api.context';

export type WorkspaceOrg = {
    code?: string;
    name?: string;
    branches?: WorkspaceBranch[];
};

export type WorkspaceBranch = {
    code?: string;
    name?: string;
};

/** `hidden` — no switcher; `branches` — branch list only; `organizations` — org (+ branch submenu when needed). */
export type WorkspaceSwitcherMode = 'hidden' | 'branches' | 'organizations';

export function isOutboxPlatform(appCode = resolveTenantAppCode()): boolean {
    return `${appCode || ''}`.trim().toLowerCase() === 'outbox';
}

export function resolveWorkspaceSwitcherMode(
    organizations: WorkspaceOrg[],
    appCode = resolveTenantAppCode(),
    selectedOrganization: WorkspaceOrg | null = null,
): WorkspaceSwitcherMode {
    const orgs = Array.isArray(organizations) ? organizations : [];
    if (!orgs.length) {
        return 'hidden';
    }

    if (isOutboxPlatform(appCode)) {
        if (orgs.length > 1) {
            return 'organizations';
        }
        const branches = orgs[0]?.branches ?? [];
        return branches.length > 1 ? 'branches' : 'hidden';
    }

    const org = selectedOrganization ?? orgs[0];
    const branches = org?.branches ?? [];
    return branches.length > 1 ? 'branches' : 'hidden';
}

export function resolveSwitcherBranches(
    organizations: WorkspaceOrg[],
    selectedOrganization: WorkspaceOrg | null,
): WorkspaceBranch[] {
    const orgs = Array.isArray(organizations) ? organizations : [];
    const org = selectedOrganization ?? orgs[0] ?? null;
    return org?.branches ?? [];
}

export function organizationNeedsBranchSubmenu(organization: WorkspaceOrg | null | undefined): boolean {
    return (organization?.branches?.length ?? 0) > 1;
}
